// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"Modal_Backdrop__2xqbE","Modal":"Modal_Modal__1ZyY3","modalTitle":"Modal_modalTitle__31lu7","closeButton":"Modal_closeButton__2iArC"};